import {CONFIG} from "./config";

export enum TImageModel {imLista, imMedalha, imMethodo, imColor, imCluster, imBranded, imBlended, imPackage, imProduto, imMeritum, imBlstyle, imCertify, imCertrue, imPatente, imGatewey, imHotspot, imProfile, imStories, imUsuario, /*//#NOUSE*/ imCheckin, imPendent}
export enum TImageSpace {isNone, isLine, isSobre, is05px, is10px, is20px}


export enum TAddDel           {adNao, adAdd, adDel}

export enum TLoginTipo        {loStarting, loRegister, loPassword, loFacebook, loDocument}

export enum TSoftware         {swBridge, swMonitor, swMontric, swDesktop, swHandapp}
export enum TAction           {acNone, acNada, acFind, acLupa, acLoad, acList, acFull, acWait, acFila, acLoja, acSave, acEdit, acFile, acFoto, acInit, acAuth, acOpen, acAbre, acDoor, acIpad, acFake, acSelf, acUser, acTeam, acShip, acWork, acLove, acMigo, acChip, acRede, acSend, acView, acShow, acFeed, acHave, acMode, acMove, acItem, acBill, acDoit, acAcao, acExec, acExit, acSair, acDone, acBack, acLixo, acLost, acLock, acLast, acBeer, acJwto, acHome, acMenu, acQtde, acLess, acCash, acCoin, acDown, acBank, acNota, acAgio, acSale, acGate, acPago, acTaxa, acGera, acTeto, acMore, acMais, acPlus, acBorn, acDate, acTime, acHora, acYear, acFlag, acFree, acJump, acAppx, acInfo, acHoje, acData, acTipo, acDeem, acHttp, acLink, acRead, acHide, acJson, acPage, acSafe, acSpot, acTrad, acLook, acOlho, acRule, acRole, acTwin, acCard, acSeal, acDesk, acSync, acSynk, acSynq, acPush, acMail, acCode, acCria, acNovo, acBook, acGoin, acNoro, acBell, acStar, acSexo, acSexe, acHtml, acLeto, acCert, acEmit, acSate, acBand, acFood, acOnde, acQuem, acDedo, acTemp}

export enum TRuleValue        {rvRulePorc, rvRuleReal}
export enum TWeekday          {wdSegunda, wdTerca, wdQuarta, wdQuinta, wdSexta, wdSabado, wdDomingo}
export enum TMonth            {mnNenhum, mnJaneiro, mnFevereiro, mnMarco, mnAbril, mnMaio, mnJunho, mnJulho, mnAgosto, mnSetembro, mnOutubro, mnNovembro, mnDezembro}

export enum TShareupTipo      {shNone, shProfile, shBrand, shMeritum, shHotspot, shSpotday, shVoucher, shBookpex}

export enum THotpageLoading   {hlBranded, hlHotspot}
export enum THotpageContent   {hcAction, hcBanner, hcSocial, hcCheckin, hcBirthday, hcBranded, hcDelivery, hcVoucher, hcEvento, hcLogado, hcNotice, hcPlace, hcPhoto, hcVideo, hcMusic, hcMusical, hcMeritum, hcHotlove, hcFriendy, hcUsuario, hcAddress}
export enum THotpageAnimate   {haDefault, haBlocki, haEntire, haValued, haHeader, haButton, haGround}
export enum THotpageLogotype  {hlDefault, hlAction, hlBanner}
export enum THotpageHistoria  {hhHidden, hhLogotipo, hhSocial, hhPlace, hhBranded, hhUsuario}
export enum THotpageFeedback  {hfHidden, hfLogotipo, hfSocial, hfCheckin}

export enum TProfileSexo      {psNenhum, psMasculino, psFeminino}
export enum TProfileSexe      {psMaleFema, psUnisex, psDeles, psEles, psDoDa, psNoNa, psAoAa, psOoAa, psGiria}
export enum TProfileFlag      {pfGhost, pfActive, pfOutime, pfDelete, pfBanido, pfMemory}
export enum TProfileTeam      {mkNenhum, mkHelping, mkPartner, mkManager}
export enum TPrivacyFlag      {pvInativo, pvAmigos, pvPublico}
export enum TReceitaFlag      {rsNenhum, rsAprovado, rsNegado}

export enum TContatoTipo      {coNone, coOlha, coMail, coFone, coChip, coFace, coInst, coTube, coTify, coTikt, coTwit}
export enum TContatoFlag      {cfNone, cfCode, cfAuth}

export enum TAddressTipo      {adSede, adApto, adLote}

export enum TPlasticSafe      {psNone, psWait, psSafe}

export enum TDevicerScan      {dsNone, dsEntraki, dsWorkday, dsCheckin, dsComanda}
export enum TDevicerBios      {dbNone, dbIos, dbAndroid, dbWindows, dbLinux, dbTap}
export enum TDevicerFrom      {dfNone, dfDesktop, dfMobile, dfMachine}
export enum TDevicerHttp      {dhNone, dhApp, dhWeb, dhExe}

export enum TFollowup         {fwNenhum, fwSeguidor, fwInimigo}
export enum TFolloweLock      {fwLiberado, fwLimitado, fwInformativo, fwDocumentoFalso, fwRelacaoSexual, fwFugiu, fwFraude, fwOfensa, fwAgressao, fwDroga, fwTrafico, fwFurto, fwArma}
export enum TChavecoFlag      {chNull, chRequest, chRecusou, chAceitou}




export enum THotspotFlag      {hfHotspotNenhum, hfHotspotTrial, hfHotspotAberto, hfHotspotLimitado, hfHotspotBloqueado, hfHotspotSuspenso, hfHotspotFechado}
export enum THotspotList      {hlNegocio, hlZipcity, hlVersion}  //{cwUnidade, cwCidade, cwRegiao, cwEstado, cwRegion, cwCountry}

export enum TUsuarioDono      {udPDV, udADM, udERP}
export enum TUsuarioRole      {urNenhum, urCEO, urVP, urDiretor, urGestor, urOperador}

export enum TProfileAlma      {paNão, paCheckin, paLancaki, paCheckir}
export enum TMonitorDoby      {dyLancamento, dyProximo}
export enum TMonitorUnir      {muMaior, muProporcional}
export enum TPrinterBind      {ppLancado, ppCheckin, ppCluster, ppProduto, ppSozinho, ppUnidade}

export enum TVersionBeta      {vbDisabled, vbDeveloper, vbSupport, vbBetatest, vbRelease}
export enum TVersionText      {vtFull, vtInfo, vtName}
export enum TAcessoFind       {afFindID, afFindNoro, afFindRnid}

export enum TFinanceSide      {cdTodos, cdCredito, cdDebito}
export enum TFinanceView      {ceCash, ceCent, ceQtde}
export enum TFinanceDate      {fdDia, fdMes, fdAno, fdEra}
export enum TPaymentFlag      {cpNone, cpProcess, cpCancelado, cpRealizado, cpEstornado, cpChargeback}
export enum TPaymentStep      {psNone, psPrevisto, psLiquidado, psResgatado}

export enum TContaby          {ccNone, ccAtivo, ccPassivo, ccReceita, ccDespesa, ccResults}

export enum TGeradorLine      {glNenhum, glSemana, glQuinze, glMensal, glBimestral, glTrimestral, glSemestral, glAnual}
export enum TGeradorFlag      {ctNenhum, ctAberto, ctParado, ctDesistiu, ctExpirado, ctFechou, ctVendeu, ctPreco, ctServico, ctAtendimento, ctDesacordo, ctPagamento}
export enum TGeradorView      {cvGanhoMrr, cvPerdaChurn}

export enum TPaybookTipo      {pbNone, pbCron, pbCard, pbMesa, pbSend, pbSale, pbTake}
export enum TPaybookModo      {pmNone, pmUser, pmNear, pmCode, pmDedo}
export enum TPaybookFlag      {pfNone, pfOpen, pfWalk, pfBill, pfLock, pfNota}
export enum TPaybookFato      {ctVencido, ctVencer}
export enum TCarsale          {csValida, csNormal, csPayout, csMerito, csTicket}

export enum TConviteTipo      {ctConvitePorta, ctConviteLista, ctConviteVenda}

export enum TConsumoFlag      {cfTudo, cfLancado, cfPerdido, cfDevolve}
export enum TConsumoCalc      {ccVenda, ccLucro, ccGorjeta, ccCusto}
export enum TConsumoStok      {cmNone, cmMove, cmBack} //0 - Nao movimentou, 1 - Saiu, 2 Voltou  ##Isso é estoque?

//export enum TInvoiceMode      {nfNone = 0, nfNFS = 88, nfNFE = 55, nfNFC = 65, nfSAT = 59}
export enum TInvoiceMode      {nfNone, nfNFS, nfNFE, nfNFC, nfSAT}
export enum TInvoiceFlag      {nfNone, nfProcess, nfContingencia, nfRejeitada, nfEmitida, nfDenegada, nfCancelada, nfInutiliza}
export enum TFiscalRegime     {frNenhum, frSimples, frPresumido, frReal}



export enum TMethodoTipo      {mtNone, mtCash, mtTran, mtLeto, mtCard, mtVale, mtGift, mtGuia, mtJuro, mtTaxa}

export enum TBrandedQuem      {whNone, whDesk, whFood}
export enum TBrandedTipo      {btNone, btMarca, btGrupo, btFiliado, btFranquia}
export enum TBrandedLock      {blNone, blEdit, blLock}

export enum TClusterTipo      {clNone, clService, clEnjoy, clMarket, clMagazine, clSport, clBuild}

export enum TBlendedTipo      {btNone, btProduto, btServico, btConvite, btCertify}
export enum TBlendedMove      {bvNone, bvQtde, bvUnit}

export enum TProdutoSale      {psNao, psSim, psPeso, psAdd}
export enum TProdutoTipo      {ptNone, ptDoor, ptCard, ptSeal, ptPack, ptDive, ptCase, ptDate, ptHour, ptTime, ptKing}
export enum TProductUnid      {puNone, puUn, puLt, puKg, puFt}
export enum TProdutoAuth      {paNone, paHide, paUser, paGift, paAuto}

export enum TMeritumAuth      {maNone, maUser, maRise}
export enum TCertifyFlag      {cfStatus, cfInativo, cfInscrito, cfAprovado, cfExpirado, cfSuspenso, cfRevogado}

export enum TPrecifyMenu      {pcDefault, pcNormal, pcPopular, pcEspecial}
export enum TPrecifyOlho      {pcCash, pcGorj, pcCoin}
export enum TEstoqueOlho      {esCash, esQtde}
export enum TEstoqueView      {mlLitro, mlDose, mlFracao}
export enum TProdutoView      {pdDetalhe, pdLancar, pdPrecify, pdEstoque}

export enum TJustifyTipo      {jfNone, jfSystem, jfSexo, jfMeritum, jfHostess, jfOpenbar, jfRodizio}

export enum TMedalhaLevel     {mdNenhum, mdBronze, mdSilver, mdGold, mdRoyal}
export enum TGaleriaTipo      {gtNenhum, gtPlace, gtPhoto, gtVideo, gtMusic, gtBanner, gtScreen, gtNotice, gtAlerta}
export enum TGaleriaModo      {gmNenhum, gmPlace, gmEvent, gmLivre, gmBrand}

export enum TEnqueteTipo      {etDigitar, etEscolha, etEscotap}

export enum TPrinterTipo      {ptPrinterTodos, ptPrinterBill, ptPrinterPedy, ptPrinterEtiqueta}
export enum TProdutoImpresso  {piImpressoLancamento, piImpressoAguardando, piImpressoNormal, piImpressoNaoExcessao, piImpressoNaoUser, piImpressoTimeOut, piImpressoCancelado, piImpressoFiring, piImpressoFired, piImpressoCredito}

export enum TUpperLowerCase   {ulNormal, ulLower, ulUpper}

export enum THotspotFlague    {hsHotspotPage, hsHotspotDayz, hsHotspotCoin}
export enum TCheckinFlague    {chCheckinEntra, chCheckinEnter, chCheckinSaida, chCheckinAmigo}
export enum TVoucherFlague    {vcVoucherEmit, vcVoucherLost}

export enum TCentralTipo      {ctNenhuma, ctDevelop, ctSupport, ctProfile, ctFriendy, ctVisitor, ctChaveco, ctHotspot, ctCheckin, ctVoucher, ctParcela, ctPayment, ctGatewey, ctTeam, ctUsuario, ctCard, ctSeal}
export enum TCentralLido      {clHide, clSave, clSend, clRead}

export enum TSubjectFrom      {sfSos, sfAdm, sfCeo}
export enum TSubjectView      {svHome, svOpen, svRead, svStar, svDone}
export enum TSupportTipo      {sjSubjectCall, sjSubjectTick}
export enum TSubjectCare      {scNormality, scAtenttion, scEmergency}

export enum TFederalIbge      {fiNone, fiNorte, fiNordeste, fiCentro, fiSudeste, fiSul}

export enum TZiptipo          {zpCity, zpCode, zpCfop, zpNcmc, zpCest, zpCesn, zpIssx}


//export let TCentralLido: 'clHide' | 'clSave' | 'clSend' | 'clRead';

//export type TCentralLido = {
//    clHide: 'clHide'
//    clSave: 'clSave',
//    clSend: 'clSend',
//    clRead: 'clRead',
//}

//export interface TCentralLido {clHide: 'clHide'; clSave: 'clSave'; clSend: 'clSend'; clRead: 'clRead';}





//EXEMPLE: Convert Str em Enum
//let xx = TCentralTipo['ctChaveco'];
//console.log(TCentralTipo.ctChaveco, <TCentralTipo>parseInt('ctChaveco'), xx);



export const TReceitaNumber: any = {

    //ELLzito, NÃO PODE colocar dois digitos
    //senão da pal, exemplo: "01", "04", ...

    rfReceitaSucesso:         0,    //{"codigoRetorno":"00","mensagemRetorno":"OK","dataConsulta":"05/10/2015","horaConsulta":"17:48:48","exception":null,"nome":"CARLOS GABRIEL BITTENCOURT MORENO","codSituacaoCadastral":0,"descSituacaoCadastral":"REGULAR","dataNascimento":"30/05/1981","dataIsncricao":"27/05/1999","anoObito":"0000","dataEmissao":"05/10/2015","horaEmissao":"05:48:48","codigoControle":"15F8.9280.C950.3672","digitoVerificador":"00","mensagemObito":null}
    rfReceitaInvalid:         1,    //{"codigoRetorno":"01","mensagemRetorno":"CPF inválido.","dataConsulta":"03/10/2016","horaConsulta":"20:44:28","exception":null,"nome":"","codSituacaoCadastral":100,"descSituacaoCadastral":"","dataNascimento":"","dataIsncricao":"","anoObito":"","dataEmissao":"","horaEmissao":"","codigoControle":"","digitoVerificador":"","mensagemObito":"ATENÇÃO: consta, na base de dados da Receita Federal do Brasil, a informação de falecimento do titular deste CPF."}
    rfReceitaChamada:         2,    //{"codigoRetorno":"02","mensagemRetorno":"Parametro(s) de chamada inválido(s)","dataConsulta":"23/09/2019","horaConsulta":"20:57:28","exception":null,"nome":"","codSituacaoCadastral":100,"descSituacaoCadastral":"","dataNascimento":"","dataIsncricao":"","anoObito":"","dataEmissao":"","horaEmissao":"","codigoControle":"","digitoVerificador":"","mensagemObito":"ATENÇÃO: consta, na base de dados da Receita Federal do Brasil, a informação de falecimento do titular deste CPF."}
    rfReceitaNascidu:         3,    //{"codigoRetorno":"03","mensagemRetorno":"Data de Nascimento inválida","dataConsulta":"25/09/2019","horaConsulta":"22:08:11","exception":null,"nome":"","codSituacaoCadastral":100,"descSituacaoCadastral":"","dataNascimento":"","dataIsncricao":"","anoObito":"","dataEmissao":"","horaEmissao":"","codigoControle":"","digitoVerificador":"","mensagemObito":"ATENÇÃO: consta, na base de dados da Receita Federal do Brasil, a informação de falecimento do titular deste CPF."}
    rfReceitaNascido:         4,    //{"codigoRetorno":"04","mensagemRetorno":"Data de nascimento informada 27/09/1991 está divergente da constante na base de dados da Secretaria da Receita Federal do Brasil. Retorne a página anterior e informe-a novamente. Persistindo esta mensagem, dirija-se a uma unidade dos Correios, Banco do Brasil ou Caixa Econômica Federal. Caso esteja no exterior, dirija-se a uma representação diplomática brasileira.","dataConsulta":"14/11/2015","horaConsulta":"2:46:30","exception":null,"nome":"","codSituacaoCadastral":100,"descSituacaoCadastral":"","dataNascimento":"","dataIsncricao":"","anoObito":"","dataEmissao":"","horaEmissao":"","codigoControle":"","digitoVerificador":"","mensagemObito":"ATENÇÃO: consta, na base de dados da Receita Federal do Brasil, a informação de falecimento do titular deste CPF."}
    rfReceitaInexist:         5,    //{"codigoRetorno":"05","mensagemRetorno":"CPF não encontrado na base de dados da Receita Federal","dataConsulta":"07/10/2016","horaConsulta":"01:13:04","exception":null,"nome":"","codSituacaoCadastral":100,"descSituacaoCadastral":"","dataNascimento":"","dataIsncricao":"","anoObito":"","dataEmissao":"","horaEmissao":"","codigoControle":"","digitoVerificador":"","mensagemObito":"ATENÇÃO: consta, na base de dados da Receita Federal do Brasil, a informação de falecimento do titular deste CPF."}
                                    //{"codigoRetorno":"05","mensagemRetorno":"CPF não encontrado na base de dados da Receita Federal","dataConsulta":"07/10/2016","horaConsulta":"01:13:04","exception":null,"nome":"","codSituacaoCadastral":100,"descSituacaoCadastral":"","dataNascimento":"","dataIsncricao":"","anoObito":"","dataEmissao":"","horaEmissao":"","codigoControle":"","digitoVerificador":"","mensagemObito":"ATENÇÃO: consta, na base de dados da Receita Federal do Brasil, a informação de falecimento do titular deste CPF."}
                                    //{"codigoRetorno":"05","mensagemRetorno":"CPF: 368.148.247-01 não existe em nossa base de dados. Compareça a uma unidade da Secretaria da Receita Federal do Brasil.","dataConsulta":"22/03/2020","horaConsulta":"05:20:21","exception":null,"nome":"","codSituacaoCadastral":100,"descSituacaoCadastral":"","dataNascimento":"","dataIsncricao":"","anoObito":"","dataEmissao":"","horaEmissao":"","codigoControle":"","digitoVerificador":"","mensagemObito":"ATENÇÃO: consta, na base de dados da Receita Federal do Brasil, a informação de falecimento do titular deste CPF.","nomeSocial":"","possuiDirpf":"","captcha":null,"token":null,"letras":null}
                                    //{"codigoRetorno":"05","mensagemRetorno":"Sequência de caracteres do CAPTCHA não confere. Tente novamente.","dataConsulta":"11/03/2020","horaConsulta":"18:17:48","exception":null,"nome":null,"codSituacaoCadastral":0,"descSituacaoCadastral":null,"dataNascimento":null,"dataIsncricao":null,"anoObito":null,"dataEmissao":null,"horaEmissao":null,"codigoControle":null,"digitoVerificador":null,"mensagemObito":null,"nomeSocial":null,"possuiDirpf":null,"captcha":null,"token":null,"letras":null}
    rfReceitaDetalhe:         6,    //{"codigoRetorno":"06","mensagemRetorno":"CPF: 503.373.782-15 com dados incompletos em nossa base de dados, para regularizá-lo, compareça a uma agência do Banco do Brasil ou Caixa Econômica Federal ou dos Correios com seu CPF, identidade e título de eleitor.","dataConsulta":"28/12/2019","horaConsulta":"21:07:33","exception":null,"nome":"","codSituacaoCadastral":100,"descSituacaoCadastral":"","dataNascimento":"","dataIsncricao":"","anoObito":"","dataEmissao":"","horaEmissao":"","codigoControle":"","digitoVerificador":"","mensagemObito":"ATENÇÃO: consta, na base de dados da Receita Federal do Brasil, a informação de falecimento do titular deste CPF.","nomeSocial":"","possuiDirpf":""}
    rfReceitaServicu:        90,    //{"codigoRetorno":"90","mensagemRetorno":"O serviço não está disponível no momento. Verifique sua conexão com a internet e tente novamente.","dataConsulta":"24/03/2017","horaConsulta":"14:40:31","exception":"Token vazio","nome":null,"codSituacaoCadastral":0,"descSituacaoCadastral":null,"dataNascimento":null,"dataIsncricao":null,"anoObito":null,"dataEmissao":null,"horaEmissao":null,"codigoControle":null,"digitoVerificador":null,"mensagemObito":null}
    rfReceitaExpired:        91,    //{"codigoRetorno":"91","mensagemRetorno":"Token expirado.","dataConsulta":"24/03/2017","horaConsulta":"19:39:10","exception":" 100 - Erro na validação do TOKEN Token expirado. CR: 91 EX: TOKEN INVÁLIDO","nome":null,"codSituacaoCadastral":0,"descSituacaoCadastral":null,"dataNascimento":null,"dataIsncricao":null,"anoObito":null,"dataEmissao":null,"horaEmissao":null,"codigoControle":null,"digitoVerificador":null,"mensagemObito":null}
    rfReceitaServico:        99,    //{"codigoRetorno":"99","mensagemRetorno":"O serviço não está disponível no momento.Verifique sua conexão com a internet e tente novamente.","dataConsulta":"24/01/2023","horaConsulta":"10:00:28","exception":"ObtemSituacaoCadastralHystrix could not be queued for execution and no fallback available.","nome":null,"codSituacaoCadastral":0,"descSituacaoCadastral":null,"dataNascimento":null,"dataIsncricao":null,"anoObito":null,"dataEmissao":null,"horaEmissao":null,"codigoControle":null,"digitoVerificador":null,"mensagemObito":null,"nomeSocial":null,"possuiDirpf":null,"captcha":null,"token":null,"letras":null}
    rfReceitaService:        100,   //{"codigoRetorno":"100","mensagemRetorno":"O serviço não está disponível no momento. Verifique sua conexão com a internet e tente novamente. (100)","dataConsulta":"06/07/2017","horaConsulta":"07:17:23","exception":" 100 - Erro na validação do TOKEN O serviço não está disponível no momento. Verifique sua conexão com a internet e tente novamente. (100) CR: 100 EX: null","nome":null,"codSituacaoCadastral":0,"descSituacaoCadastral":null,"dataNascimento":null,"dataIsncricao":null,"anoObito":null,"dataEmissao":null,"horaEmissao":null,"codigoControle":null,"digitoVerificador":null,"mensagemObito":null}
    
    rfReceitaPrepare:        55,    //{"codigoRetorno":"55","mensagemRetorno":"Token Google inválido."}
    rfReceitaRequest:        88,    //{"codigoRetorno":"88","mensagemRetorno":"Read timed out."}
    rfReceitaUpdateapp:      124,   //{"codigoRetorno":"0999","mensagemRetorno":"Prezado contribuinte! Não foi possível processar a operação. Verifique se há uma atualização do aplicativo disponível na loja.","dataConsulta":"10/03/2020","horaConsulta":"19:49:13","exception":null,"nome":null,"codSituacaoCadastral":0,"descSituacaoCadastral":null,"dataNascimento":null,"dataIsncricao":null,"anoObito":null,"dataEmissao":null,"horaEmissao":null,"codigoControle":null,"digitoVerificador":null,"mensagemObito":null,"nomeSocial":null,"possuiDirpf":null,"captcha":null,"token":null,"letras":null}
    rfReceitaIntegracao:     125,   //{"codigoRetorno":"9999","mensagemRetorno":"Integração com o sistema CPF temporariamente indisponível. Por favor, tente mais tarde.","dataConsulta":"17/04/2023","horaConsulta":"01:43:36","exception":null,"nome":"","codSituacaoCadastral":100,"descSituacaoCadastral":"","dataNascimento":"","dataIsncricao":"","anoObito":"","dataEmissao":"","horaEmissao":"","codigoControle":"","digitoVerificador":"","mensagemObito":"ATENÇÃO: consta, na base de dados da Receita Federal do Brasil, a informação de falecimento do titular deste CPF.","nomeSocial":"","possuiDirpf":"","captcha":null,"token":null,"letras":null}
    rfReceitaUndefined:      126,
    rfReceitaWaiting:        127,

};

export class ENUM {

    static profileSexe(sexo: TProfileSexo, sexe: TProfileSexe, sexu: TProfileSexe = null): string {

        let result = '';

        if (sexo == TProfileSexo.psNenhum) {
            if (sexe == TProfileSexe.psMaleFema) result = 'Masculino e Feminino';
            if (sexe == TProfileSexe.psUnisex) result = 'Unisex';
            if (sexe == TProfileSexe.psDeles) result = 'Deles';
            if (sexe == TProfileSexe.psEles) result = 'Eles';
            if (sexe == TProfileSexe.psDoDa) result = 'Em';
            if (sexe == TProfileSexe.psNoNa) result = 'Em';
            if (sexe == TProfileSexe.psAoAa) result = 'Em';
            if (sexe == TProfileSexe.psOoAa) result = 'Em';
            if (sexe == TProfileSexe.psGiria) result = 'Ninguem';
        }

        if (sexo == TProfileSexo.psMasculino) {
            if (sexe == TProfileSexe.psMaleFema) result = 'Masculino';
            if (sexe == TProfileSexe.psUnisex) result = 'Mas';
            if (sexe == TProfileSexe.psDeles) result = 'Dele';
            if (sexe == TProfileSexe.psEles) result = 'Ele';
            if (sexe == TProfileSexe.psDoDa) result = 'Do';
            if (sexe == TProfileSexe.psNoNa) result = 'No';
            if (sexe == TProfileSexe.psAoAa) result = 'Ao';
            if (sexe == TProfileSexe.psOoAa) result = 'O';
            if (sexe == TProfileSexe.psGiria) result = 'Hômi';
        }

        if (sexo == TProfileSexo.psFeminino ) {
            if (sexe == TProfileSexe.psMaleFema) result = 'Feminino';
            if (sexe == TProfileSexe.psUnisex) result = 'Fem';
            if (sexe == TProfileSexe.psDeles) result = 'Dela';
            if (sexe == TProfileSexe.psEles) result = 'Ela';
            if (sexe == TProfileSexe.psDoDa) result = 'Da';
            if (sexe == TProfileSexe.psNoNa) result = 'Na';
            if (sexe == TProfileSexe.psAoAa) result = 'A';
            if (sexe == TProfileSexe.psOoAa) result = 'A';
            if (sexe == TProfileSexe.psGiria) result = 'Muiê';
        }

        if (sexu) result = result + ' ' + this.profileSexe(sexo, sexu);

        return result;

    }

    static usuarioRule(html : boolean, departa: any, usuarioRole: TUsuarioRole) {

        if (usuarioRole == TUsuarioRole.urNenhum) return '';
        if (usuarioRole == TUsuarioRole.urCEO) return 'CEO';
        if (usuarioRole == TUsuarioRole.urVP)  return 'VP';
        if (usuarioRole == TUsuarioRole.urDiretor)  return departa.DepartaNick;
        if (usuarioRole == TUsuarioRole.urGestor)  return departa.DepartaNome;
        if (usuarioRole == TUsuarioRole.urOperador) return departa.DepartaNome;

    }

    static centralColor(tipo: any, flag: any) {

        if (tipo == TCentralTipo.ctNenhuma) return CONFIG.colors.CorMenu;
        if (tipo == TCentralTipo.ctDevelop) return CONFIG.colors.CorMenu;
        if (tipo == TCentralTipo.ctSupport) return CONFIG.colors.CorRoxa;
        if (tipo == TCentralTipo.ctProfile) return CONFIG.colors.CorMenu;
        if (tipo == TCentralTipo.ctFriendy) return CONFIG.colors.CorRoxa;
        if (tipo == TCentralTipo.ctVisitor) return CONFIG.colors.CorCafe;
        if (tipo == TCentralTipo.ctChaveco) return (flag == TChavecoFlag.chAceitou ? CONFIG.colors.CorRoxa : (flag == TChavecoFlag.chRecusou ? CONFIG.colors.CorFood : CONFIG.colors.CorWhat));
        if (tipo == TCentralTipo.ctHotspot) return (flag == THotspotFlague.hsHotspotDayz ? CONFIG.colors.CorRoxa : CONFIG.colors.CorWhat);
        if (tipo == TCentralTipo.ctCheckin) return (flag == TCheckinFlague.chCheckinEnter ? CONFIG.colors.CorBlue : (flag == TCheckinFlague.chCheckinSaida ? CONFIG.colors.CorCafe : (flag == TCheckinFlague.chCheckinAmigo ? CONFIG.colors.CorWeek : CONFIG.colors.CorMenu)));
        if (tipo == TCentralTipo.ctVoucher) return (flag == TVoucherFlague.vcVoucherEmit ? CONFIG.colors.CorWeek : CONFIG.colors.CorVerm);
        if (tipo == TCentralTipo.ctParcela) return (flag == TPaybookFato.ctVencer ? CONFIG.colors.CorLime : CONFIG.colors.CorVerm);
        if (tipo == TCentralTipo.ctPayment) return (flag == TPaymentFlag.cpRealizado ? CONFIG.colors.CorLime : (flag == TPaymentFlag.cpEstornado ? CONFIG.colors.CorFogo : CONFIG.colors.CorVerm));
        if (tipo == TCentralTipo.ctGatewey) return CONFIG.colors.CorRoxu;
        if (tipo == TCentralTipo.ctTeam)    return CONFIG.colors.CorWeek;
        if (tipo == TCentralTipo.ctUsuario) return CONFIG.colors.CorWeek;
        if (tipo == TCentralTipo.ctCard)    return CONFIG.colors.CorWeek;
        if (tipo == TCentralTipo.ctSeal)    return CONFIG.colors.CorAbra;

        return CONFIG.colors.CorMenu;

    }

    static centralIcone(tipo: any, flag: any) {

        if (tipo == TCentralTipo.ctNenhuma) return '';
        if (tipo == TCentralTipo.ctDevelop) return 'b-icon-fire-2';
        if (tipo == TCentralTipo.ctSupport) return 'b-icon-comment-6';
        if (tipo == TCentralTipo.ctProfile) return;
        if (tipo == TCentralTipo.ctFriendy) return 'b-icon-arrow-curved';
        if (tipo == TCentralTipo.ctVisitor) return 'b-icon-eye-1';
        if (tipo == TCentralTipo.ctChaveco) return 'b-icon-whatsapp';
        if (tipo == TCentralTipo.ctHotspot) return 'b-icon-location';

        //Curtida de Checkin... chCheckinLike = 'b-icon-heart-7'
        if (tipo == TCentralTipo.ctCheckin) return (flag == TCheckinFlague.chCheckinEnter ? 'b-icon-credit-card-4' : 'b-icon-location-5');
        if (tipo == TCentralTipo.ctVoucher) return (flag == TVoucherFlague.vcVoucherEmit ? 'b-icon-exchange' : 'b-icon-cancel-1');
        if (tipo == TCentralTipo.ctParcela) return (flag == TPaybookFato.ctVencer ? 'b-icon-bag' : 'b-icon-cancel-1');
        if (tipo == TCentralTipo.ctPayment) return (flag == TPaymentFlag.cpRealizado ? 'b-icon-bag' : (flag == TPaymentFlag.cpEstornado ? 'b-icon-cancel-1' : 'b-icon-cancel-1'));
        if (tipo == TCentralTipo.ctGatewey) return 'b-icon-dollar';
        if (tipo == TCentralTipo.ctTeam)    return 'b-icon-plus';
        if (tipo == TCentralTipo.ctUsuario) return 'b-icon-user-add';
        if (tipo == TCentralTipo.ctCard)    return 'b-icon-asterisk';
        if (tipo == TCentralTipo.ctSeal)    return 'b-icon-star';

        return '';

    }

    static devicerIcon(devicerBios: TDevicerBios): string {

        if (devicerBios == TDevicerBios.dbIos)     return 'b-icon-apple';
        if (devicerBios == TDevicerBios.dbAndroid) return 'b-icon-android';
        if (devicerBios == TDevicerBios.dbWindows) return 'b-icon-windows';
        if (devicerBios == TDevicerBios.dbLinux)   return 'b-icon-linux';

        return null;

    }

    static paybookTipo(tipo, info: 'text' | 'icon') {

        if (tipo == TPaybookTipo.pbCron) return (info == 'text' ? 'Contrato' : 'b-icon-feather');
        if (tipo == TPaybookTipo.pbCard) return (info == 'text' ? 'Comanda' : 'b-icon-user');
        if (tipo == TPaybookTipo.pbMesa) return (info == 'text' ? 'Mesa' : 'b-icon-resize-full-3');
        if (tipo == TPaybookTipo.pbTake) return (info == 'text' ? 'Retirar' : 'b-icon-shopping-bag');
        if (tipo == TPaybookTipo.pbSend) return (info == 'text' ? 'Entrega' : 'b-icon-motorcycle');
        if (tipo == TPaybookTipo.pbSale) return (info == 'text' ? 'Balcão' : 'b-icon-shopping-bag');

    }

    static paybookModo(tipo, info: 'text' | 'icon') {

        if (tipo == TPaybookModo.pmUser) return (info == 'text' ? 'Digitado' : 'b-icon-user');
        if (tipo == TPaybookModo.pmNear) return (info == 'text' ? 'Aproximação' : 'b-icon-wifi');
        if (tipo == TPaybookModo.pmCode) return (info == 'text' ? 'QRCode' : 'b-icon-qrcode');
        if (tipo == TPaybookModo.pmDedo) return (info == 'text' ? 'Biometria' : 'b-icon-up-hand');

    }

    static certifyFlag(status: any, tipo: 'hash' | 'text' | 'icon') {

        if (status == TCertifyFlag.cfStatus)   return (tipo == 'hash' ? CONFIG.colors.CorGelo : (tipo == 'text' ? 'CorGelo' : 'b-icon-stop'));
        if (status == TCertifyFlag.cfInativo)  return (tipo == 'hash' ? CONFIG.colors.CorMenu : (tipo == 'text' ? 'CorMenu' : 'b-icon-stop'));
        if (status == TCertifyFlag.cfInscrito) return (tipo == 'hash' ? CONFIG.colors.CorCafe : (tipo == 'text' ? 'CorCafe' : 'b-icon-clock-1'));
        if (status == TCertifyFlag.cfAprovado) return (tipo == 'hash' ? CONFIG.colors.CorLime : (tipo == 'text' ? 'CorMato' : 'b-icon-ok'));
        if (status == TCertifyFlag.cfExpirado) return (tipo == 'hash' ? CONFIG.colors.CorWeek : (tipo == 'text' ? 'CorWeek' : 'b-icon-clock-1'));
        if (status == TCertifyFlag.cfSuspenso) return (tipo == 'hash' ? CONFIG.colors.CorPele : (tipo == 'text' ? 'CorPele' : 'b-icon-block'));
        if (status == TCertifyFlag.cfRevogado) return (tipo == 'hash' ? CONFIG.colors.CorVerm : (tipo == 'text' ? 'CorVerm' : 'b-icon-cancel-5'));

        return (tipo == 'hash' ? CONFIG.colors.CorGelo : (tipo == 'text' ? 'CorGelo' : 'b-icon-cog'));

    }


    static ziptipoMask(ziptipo: TZiptipo): string {

        if (ziptipo == TZiptipo.zpNcmc) return '0000.00.00';
        if (ziptipo == TZiptipo.zpCest) return '00.000.00';
        if (ziptipo == TZiptipo.zpCfop) return '0.000';

        return '';

    }

    static paymentTint(paymentFlag, corBlue?) {

        if (paymentFlag == TPaymentFlag.cpProcess)    return 'CorDash';
        if (paymentFlag == TPaymentFlag.cpCancelado)  return 'CorVerm';
        if (paymentFlag == TPaymentFlag.cpRealizado)  return (corBlue || 'CorLime');
        if (paymentFlag == TPaymentFlag.cpEstornado)  return 'CorFogo';
        if (paymentFlag == TPaymentFlag.cpChargeback) return 'CorFire';

    }

    static paymentSide(payment, flug: 'side' | 'full') {

        if (flug == 'side') {
            if (payment.PaymentSide == TFinanceSide.cdTodos)   return 'A vista';
            if (payment.PaymentSide == TFinanceSide.cdDebito)  return 'Débito';
            if (payment.PaymentSide == TFinanceSide.cdCredito) return 'Crédito';
        }

        if (flug == 'full') {
            if (payment.PaymentSide == TFinanceSide.cdTodos)   return payment.Methodo.MethodoNome;
            if (payment.PaymentSide == TFinanceSide.cdDebito)  return payment.Methodo.MethodoNome + ' Débito';
            if (payment.PaymentSide == TFinanceSide.cdCredito) return payment.Methodo.MethodoNome + ' Crédito';
        }

    }

    static paybookCash(checkin, casheye: null | 'Deve' = null, userset: any = null): number {

        if (!checkin) return 0;

        //#SYNC|DESK# - #GAMBI - DESK vs SYNC
        if (!checkin.Consumos) {
            return checkin.PaybookCash;
        }
        
        let desk = true;
        let consumos = checkin.Consumos.filter(CS => CS.Consumo.ConsumoFlag == TConsumoFlag.cfLancado);
        
        let item = 0;
        consumos.forEach(CS => {
            //#DESK
            if ( desk) item = item + (CS.Consumo.ConsumoQtde * CS.Consumo.ConsumoCash) + CS.Consumo.ConsumoMore - CS.Consumo.ConsumoLess;

            //#SYNC
            if (!desk) item = item + (CS.Consumo.ConsumoQtde * (CS.Consumo.ConsumoCash + (CS.Consumo.ConsumoMore || 0) - CS.Consumo.ConsumoLess));
        });


        let pago = 0;
        checkin.Parcelas.forEach(PL => {
            if (PL.Payjoins) PL.Payjoins.forEach(PJ => PJ.Payments.forEach(PA => pago = pago + (PA.PaymentFlag >= TPaymentFlag.cpRealizado ? PA.PaymentCash : 0)))
        });
      //let pago = this.util.jsSum(checkin.Parcelas, ['Payjoins', 'Payments', 'PaymentCash'], 'PaymentFlag', [TPaymentFlag.cpRealizado, TPaymentFlag.cpEstornado, TPaymentFlag.cpChargeback]);

        let deve = (item - pago);
        if ( userset && checkin.PaybookBora && deve == 0) deve = item;
        if (!userset && checkin.PaybookBora && deve < 0) deve = 0;
        if (casheye == 'Deve' && deve < 0) deve = 0; //Quero sempre quanto DEVE

        return parseFloat(deve.toFixed(2));

    }

    static scannerMask(scanerText: string): string {

        return scanerText;

    }

    static scannerRead(numero: string, settingBars: number): number {

        //#Tarja-Magnetica - High
        if (numero.length > 1 && numero[0] == '%') {
            // if (numero.indexOf('?') > 0) numero = Copy(Numero, 02, Pos('?', Numero)-2)
            // else numero = Copy(Numero, 02, numero.length);
            
            // if (numero.indexOf(':') > 0) numero = Copy(Numero, 01, Pos(':', Numero)-1)
            // else numero = Copy(Numero, 01, Length(Numero));
           
            //#GAMBI ~> fSaida em //#Tarja-Magnetica - High %22050?;22050?+22050? (3 trilhas)
        }
      
        numero = numero.trim();
        if (numero == '') numero = '0';
        if (numero == '0' || settingBars == 0) return parseInt(numero);
      
        //If 'Cheff Solutions' Then Begin
        //   Result := Copy(Numero, 01, 01) + Copy(Numero, 04, Length(Numero)-4);
        //   Exit;
        //End;
      
        return parseInt(numero) + (settingBars * 1000);

    }

}




// WEBPACK FOOTER //
// ./src/app/enum.ts